import { OrdersListPage } from './OrdersListPage';
export function OrdersB2bPage() { return <OrdersListPage orderType="B2B" />; }
